<div ui-view>
  <neo-list data="vm.data"></neo-list>
</div>
